const Dots = ({ classN }: { classN: string }) => {
  return <div className={classN}></div>;
};

export default Dots;
